import { render, staticRenderFns } from "./sidebar-va.vue?vue&type=template&id=5d2c0e1e&scoped=true&"
import script from "./sidebar-va.vue?vue&type=script&lang=js&"
export * from "./sidebar-va.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-va.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sidebar-va.vue?vue&type=style&index=1&id=5d2c0e1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c0e1e",
  null
  
)

export default component.exports